export enum NavBarTheme {
  LIGHT,
  DARK,
}
